<template>
    <gofix-card class="cardTable chartOfAccount" fullContent>
        <gofix-table
                :column-width-setting="columnWidthSetting"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="showModalMassSchedule"
                @change-selected="changeSelectedTable"
                @export="exportItems"
                @import-items="importItems"
                ref="gofixTable">
            <template slot="gofix_table:after-control-left" slot-scope="data">
                <template v-if="settings.showBtnMassSchedule">
                    <gofix-button id="gofix-button-mass" class="ml-2" label="Mass Schedule" @click="showModalMassSchedule" outline></gofix-button>
                    <b-tooltip target="gofix-button-mass" title="Mass Schedule"></b-tooltip>
                </template>
            </template>
            <template slot="gofix_table:before-control-right" slot-scope="data" v-if="settings.showDropDownMaint">
                <div class="mr-2 d-flex align-items-center filterCompany filterMaint">
                    <span class="mr-1 title">Maint. Program</span>
                    <gofix-form-dropdown
                            :class="[ 'highlightDropdown chartOfAccountDropdown min-width-0', classInput ]"
                            label=""
                            vLabel="description_one"
                            :clearable="false"
                            :filterable="false" 
                            :options="maintPrograms"
                            v-model="maintProgram"
                            :placeholder="'Maint. Program'"
                            @search="searchMaintProgram">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <span class="text-hidden-one-row">{{ `${option.description_one}` || '-' }}</span>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            <div class="maintOption">
                                <span>{{ option.description_one || '-' }}</span>
                            </div>
                        </template>
                    </gofix-form-dropdown>
                </div>
            </template>
            <template slot="gofix_table:type_abbreviation" slot-scope="row">
                {{ row.item.coming_job && row.item.coming_job.maintenance && row.item.coming_job.maintenance.abbreviation ? row.item.coming_job.maintenance.abbreviation : '' }}
            </template>
            <template slot="gofix_table:maint_description" slot-scope="row">
                {{ row.item.coming_job && row.item.coming_job.maintenance && row.item.coming_job.maintenance.description_one ? row.item.coming_job.maintenance.description_one : '' }}
            </template>
            <template slot="gofix_table:last_activity" slot-scope="row">
                <template v-if="row.item.last_job && row.item.last_job.planned_date">
                    <router-link target="_blank" class="text-dark" :to="`/v2/job-list/${row.item.last_job.id}`">
                        <span class="text-decoration-underline">{{ row.item.last_job.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                    </router-link>
                </template>
            </template>
            <template  slot="gofix_table:upcoming_activity" slot-scope="row">
                <template v-if="row.item.coming_job && row.item.coming_job.planned_date">
                    <router-link target="_blank" class="text-dark" :to="`/v2/job-list/${row.item.coming_job.id}`">
                        <span class="text-decoration-underline">{{ row.item.coming_job.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                    </router-link>
                </template>
                <template v-else>
                    <gofix-button 
                        outline
                        class="btnUpcomingService" 
                        label="Schedule" 
                        :disabled="(
                            maintProgram && maintProgram.id != 'all' && 
                            row.item.coming_job != null)"
                        @click="showModalMassSchedule(row.item)"></gofix-button>
                </template>
            </template>
            <template slot="gofix_table:import-content" slot-scope="row">
                <h6><u><i>Project Template - New Version</i></u></h6>
                <gofix-button @click="downloadTemplate" label="Project-Template.csv" outline>
                    <template  slot="gofix:button:afterLabel">
                        <i class="icon-cloud-download icons font-xl ml-2"></i>
                    </template>
                </gofix-button>
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open" @close="() => {
            this.modal.data.maintenance = null;
        }">
            <b-form class="pb-20">
                <gofix-form-dropdown
                    label="Maintenance Program"
                    vLabel="description_one"
                    :filterable="false" 
                    :append-to-body="true"
                    :options="popupMaintPrograms"
                    v-model="modal.data.maintenance"
                    placeholder=" "
                    @search="searchMaintProgram">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <div class="maintOption">
                            <span>{{ option.description_one || '-' }}</span>
                        </div>
                    </template>
                </gofix-form-dropdown>
                <gofix-form-dropdown 
                    vLabel="contract_reference_number"
                    label="Project" 
                    :filterable="false" 
                    :options="modal.options.scontracts" 
                    v-model="modal.data.supplier_contract" >
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span>{{ option.contract_reference_number || '--' }}</span>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <span>{{ option.contract_reference_number || '--' }}</span>
                    </template>
                </gofix-form-dropdown>
                <gofix-form-properties
                    label="Property Location"
                    :contract-id="this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null"
                    :property-id="this.ClientContractID && this.ClientContractID.property_root_id ? this.ClientContractID.property_root_id : null"
                    v-model="modal.data.property_id">
                </gofix-form-properties>
                <gofix-form-input-date
                    v-model="modal.data.date"
                    label="Date">
                </gofix-form-input-date>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="checkScheduledJob" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Modal Schedule Job -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.checkSchedule.open">
            <div class="center">These project already had<br><strong>a schedule</strong></div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.checkSchedule.open = false">Cancel</b-button>
                <b-button class="custom-btn" @click="createSchedule">Override</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.export.title" hide-footer :centered="true" v-model="modal.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modal.export.process}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
    </gofix-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';

    export default {
        name: "scontract-schedule",
        props: {
            nameTable: {
                type: String,
                default: "preventive-maintenance-property-schedule"
            },
            settings: {
                type: Object,
                default: {
                    showBtnMassSchedule: false,
                    showDropDownMaint: false,
                    create: false
                }
            },
            scontract: {
                type: Object,
                default: null
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['scontract_schedule']));
            return {
                columnWidthSetting:
                {
                    leftWidth:5,
                    rightWidth:7
                },
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: false,
                        delete: false,
                        tableExport: false,
                    },
                    filter: filter,
                    buildFilter: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "contract_title",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: "actions",
                            label: "",
                            thStyle: "width:65px"
                        },
                        {
                            key: "contract_reference_number",
                            label: "Project Ref",
                            thStyle: "width:150px",
                            isActive: true,
                            isFilter: true
                        },
                        {
                            key: "last_activity",
                            label: "Last Activity",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true
                        },
                        {
                            key: "upcoming_activity",
                            label: "Upcoming Activity",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true
                        },
                        {
                            key: "type_abbreviation",
                            label: "Type Abbreviation",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true
                        },
                        {
                            key: "maint_description",
                            label: "Maint Description",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true
                        },
                    ]
                },
                tableItems:[],
                maintProgram: {
                    id: 'all',
                    description_one: 'All'
                },
                maintPrograms: [],
                popupMaintPrograms: [],
                timer: {
                    fm_staff: null,
                },
                modal:{
                    title: 'Project Schedule',
                    open: false,
                    loading: false,
                    status:false,
                    ids: [],
                    data: {
                        maintenance: null,
                        supplier_contract: null,
                        date: null,
                        property_id: null
                    },
                    checkSchedule: {
                        open: false,
                    },
                    export: {
                        open: false,
                        loading: false,
                        process: 'Importing file',
                        title: 'Import Data'
                    },
                    options: {
                        scontracts: []
                    }
                },
                timer: {
                    maint: null,
                    modal: null,
                    property: null
                },
                classInput: "width-175",
                innerWidth: 0,
            }
        },
        watch: {
            maintProgram: function(val) {
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            innerWidth: function(val) {
                this.$nextTick(() => { 
                    if(val <= 1680) {
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-mass');
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-pre');
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-download');
                    } else {
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-mass');
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-pre');
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-download');
                    }
                });
            },
            ClientContractID: function() {
                this.getSContracts();
                this.getMaintProgram();
            },
            scontract: function() {
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: "ContractController/ClientContractID"
            })
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            this.getSContracts()
        },
        created() {
            this.tableConfig.controls.create = this.settings.create;
            if(this.settings.title_modal) {
                this.modal.title = this.settings.title_modal
            }
            if(this.settings.showDropDownMaint) {
                this.getMaintProgram();
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            changeSelectedTable(val) {
                this.modal.ids = val;
            },
            handleResize() {
                this.innerWidth = window.innerWidth;
                this.classInput = "width-175";
                if (window.innerWidth < 1500) {
                    this.classInput = "width-99"
                }
            },
            showModalMassSchedule(item = null) {
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    return this.$alertNotification("Please select contract selector before processing job schedule", "danger");
                }

                if(!item && this.modal.ids.length > 1) {
                    return this.$alertNotification("Please select only 1 project before processing the job schedule.", "danger");
                }

                this.popupMaintPrograms     = this.maintPrograms.filter(item => item.id != 'all');
                this.modal.data.maintenance = this.maintProgram.id != 'all' ? this.maintProgram : null;

                if(this.modal.ids.length) {
                    let filterItems = this.modal.options.scontracts.filter(item => this.modal.ids.includes(item.id))
                    if(filterItems.length) this.modal.data.supplier_contract =  filterItems[0]
                } else {
                    this.modal.data.supplier_contract = this.scontract || item
                }

                this.modal.data.date = null;
                this.modal.data.property_id = null;
                this.modal.status = false;
                    
                this.modal.loading = false;
                this.modal.open = true;
            },
            async getMaintProgram(search = null, is_popup = false) {
                if(!this.ClientContractID || !this.ClientContractID.contract_terms || !this.ClientContractID.contract_terms.length) {
                    if(!is_popup) {
                        this.maintPrograms = [{
                            id: 'all',
                            description_one: 'All'
                        }];
                    } else {
                        this.popupMaintPrograms = [];
                    }

                    return
                }

                let filters = {
                    search:             search,
                    sor_code:           'WSH',
                    contract_term_id:   this.ClientContractID.contract_terms[0].id,
                    is_maintenance:     true,
                    is_master:          false,
                    // is_equipment_group_empty: true
                }
                
                await this.$store.dispatch("v2SorController/getItems", {
                    isCMS: false,
                    page: -1,
                    limit: 100,
                    group_id: 0,
                    filter: filters
                })
                .then(response => {
                    if(!is_popup) {
                        this.maintPrograms = [{
                            id: 'all',
                            description_one: 'All'
                        }].concat(response.items);
                    } else {
                        this.popupMaintPrograms = response.items;
                    }
                })
                .catch(err => {
                    this.maintPrograms = [];
                })
            },
            async searchMaintProgram(search, loading) {
                loading(true)
                this.maintPrograms = []
                if (this.timer.maint) {
                    clearTimeout(this.timer.maint);
                    this.timer.maint = null;
                }
                this.timer.maint = setTimeout(async () => {
                    try {

                        let is_popup = false;
                        if(this.modal.open)
                            is_popup = true;

                        await this.getMaintProgram(search, is_popup);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            checkScheduledJob() {
                if(!this.modal.data.supplier_contract) {
                    return this.$alertNotification("Project is required", "danger");
                }

                if(!this.modal.data.maintenance) {
                    return this.$alertNotification("Maintenance program is required", "danger");
                }

                if(!this.modal.data.property_id) {
                    return this.$alertNotification("Property location is required", "danger");
                }

                if(!this.modal.data.date) {
                    return this.$alertNotification("Date is required", "danger");
                }

                if(moment(this.modal.data.date).isBefore(moment(), 'day')) {
                    return this.$alertNotification("The date must be greater than or equal to the current date.", "danger");
                }

                let request = {
                    maintenance_id: this.modal.data.maintenance.id,
                    supplier_contract_id: this.modal.data.supplier_contract.id,
                    property_id: this.modal.data.property_id,
                    // planned_date:   moment(this.modal.data.date).format('YYYY-MM-DD')
                }
                if (this.timer.modal) {
                    clearTimeout(this.timer.modal);
                    this.timer.modal = null;
                }
                this.timer.modal = setTimeout(async () => {
                    this.$store.dispatch("SContractProjectController/checkExistingProject", request)
                    .then(response => {
                        let result = response.data.data;
                        if(!result.existing) {
                            this.createSchedule();
                            return;
                        }

                        this.modal.checkSchedule.open = true;
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }, 200);
            },
            createSchedule() {
                this.modal.loading = true;
                this.modal.checkSchedule.open = false;

                let requestParams = {
                    maintenance_id: this.modal.data.maintenance.id,
                    client_contract_id: this.ClientContractID.id,
                    supplier_contract_id: this.modal.data.supplier_contract.id,
                    start_date: moment(this.modal.data.date).format('YYYY-MM-DD'),
                    end_date: moment(this.modal.data.date).format('YYYY-MM-DD'),
                    property_id: this.modal.data.property_id,
                    supplier_contract_title: this.modal.data.supplier_contract.contract_title,
                    supplier_contract_reference_number: this.modal.data.supplier_contract.contract_reference_number,
                }
                
                this.$store.dispatch("SContractProjectController/generateJobsProject", requestParams)
                .then(response => {
                    this.modal.open = false;
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$alertNotification(this.$notificationV2('schedule', 's_contract_schedule'));
                })
                .catch(err => {
                    this.modal.loading = false;
                })
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    this.tableItems = [];
                    resolve({
                        items: [],
                        total: 0
                    });
                    return;
                }

                tableRequest.filter.client_contract_id.value = this.ClientContractID.id;
                tableRequest.filter.id.value = this.scontract ? this.scontract.id : null;
                // tableRequest.filter.property_id.value = this.ClientContractID.property_root_id;
                tableRequest.filter.maintenance_id.value = this.maintProgram ? this.maintProgram.id : 'all';

                await this.$store.dispatch("SContractProjectController/getJobs", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the jobs", "danger");
                        reject();
                    });
            },
            /*--- Export File ---*/
            exportItems(tableRequest) {
                return
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`SContractProjectController/importScontractSchedule`, {
                    file_import: file
                })
                .then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 's_contract_project');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    this.getSContracts();
                    this.$emit('reloadList')
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
            async getSContracts() {
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    this.modal.options.scontracts = []
                    return
                }
                this.modal.options.scontracts = true
                let tableRequest = {
                    filter: { client_contract_id: this.ClientContractID.id },
                    page: 1,
                    limit: -1
                }

                await this.$store.dispatch("SContractProjectController/getSContract", tableRequest)
                    .then(response => {
                        this.modal.options.scontracts = response.items;
                    })
                    .catch(err => {})
            },
            downloadTemplate() {
                let time = moment().valueOf();
                let link = document.createElement('a');
                link.href = `${process.env.VUE_APP_SERVER_URL}/template/s-contract-project-template.csv?v=${time}`;
                link.setAttribute('download', 'Project-Template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
</script>